import React, { useEffect } from 'react'
import successIcon from "assets/images/images_new/success-icon.png";
import { NavLink } from "react-router-dom";
import { Button } from 'react-bootstrap';
import { trackMetaEvent, trackTikTokEvent } from 'util/analytics';

const SuccessCard = () => {

  useEffect(() => {
      // Get payment details from URL params
      const urlParams = new URLSearchParams(location.search);
      const amount = urlParams.get('p') || '0.00';
      const currency = urlParams.get('currency') || 'AUD';
      const productName = urlParams.get('product_name') || 'Subscription Plan';
      const productId = urlParams.get('product_id') || 'subscription_001';
  
      // Track Purchase conversion using helper functions
      trackMetaEvent('Purchase', { 
        value: parseFloat(amount), 
        currency: currency 
      });
      trackTikTokEvent('PlaceAnOrder', {
      contents: [
        {
          content_id: productId,
          content_type: "product",
          content_name: productName,
          quantity: 1,
          price: parseFloat(amount)
        }
      ],
      value: parseFloat(amount),
      currency: currency
    });
    }, [location.search]);

  return (
   <div className="transation-page payment-successful outer-wrapper">
            <div className="successful-content">
              <img src={successIcon} alt="LA" />
              <h2>Subscription created successful</h2>
              <p>Transaction was successful <br /> and your subscription will be activate soon</p>
              <div className="payment-btns d-flex justify-content-center align-items-center">
                {/* <a href="#" className="pay-btn dashboard-btn">Go To Dashboard</a> */}
                <NavLink to={"/admin/dashboard"} className="text-decoration-none">
                <Button size="xs" className="process-payment-btn d-flex align-items-center">
                  Go to Dashboard
                </Button>
              </NavLink>
                 <NavLink to={"/admin/transaction"}>
                <Button size="xs" className="process-payment-btn d-flex align-items-center">
                  Manage Plan
                </Button>
              </NavLink>
                {/* <a href="#" className="pay-btn manage-btn">Manage Plan</a> */}
              </div>
            </div>
          </div>
  )
}

export default SuccessCard
